import { SharedContent } from './shared-content';

export const AssumeInheritContent = {
  header: 'Understand your options for inheriting an IRA',
  headerRoth: 'Understand your options for inheriting a Roth IRA',
  main: 'As a spouse and sole beneficiary, you have the option to assume the decedent’s IRA and treat it as your own. Please note, if you choose to inherit the account now, you can still assume it later. ',
  continueButton: 'Continue',
  errorText: SharedContent.radioRequiredError,
  radioLabel: 'Select',
  assumeIRA: {
    header: 'Assume the IRA',
    headerRoth: 'Assume the Roth IRA',
    subHeader: 'Transfers into your name',
    contributions: {
      title: 'Contributions',
      description: 'You <b>can</b> contribute the maximum amount each year.',
    },
    distributions: {
      title: 'Distributions',
      bullets: [
        'Any distributions taken before age 59.5 will be included inyour taxable income and may be subject to an additional 10% tax.',
        'Once you reach age 59.5, penalty-free distributions can be taken at anytime.',
      ],
      bulletsRoth: [
        'Distributions can be taken out at any time, penalty-free, if the 5-year holding period for Roth IRAs was met and the decedent was at least 59.5 years old.',
        'If the account has not met the 5-year holding period, withdrawals of earnings may be subject to income tax.',
      ],
    },
    rmd: {
      title: 'Required Minimum Distribution (RMD)',
      description: 'You’ll start taking RMD’s at age 73.',
      descriptionRoth: 'There are no RMD requirements for an assumed Roth IRA.',
    },
  },
  inheritIRA: {
    header: 'Inherit the IRA',
    headerRoth: 'Inherit the Roth IRA',
    subHeader: 'Transfers into an inherited IRA',
    subHeaderRoth: 'Transfers into an inherited Roth IRA',
    contributions: {
      title: 'Contributions',
      description: 'You <b>can’t</b> contribute to an inherited IRA.',
      descriptionRoth: 'You <b>can’t</b> contribute to an inherited Roth IRA.',
    },
    distributions: {
      title: 'Distributions',
      bullets: [
        'Generally, you can choose to start taking distributions December 31 of the year after the decedent’s passing, or the year the decedent would’ve turned 73.',
        'You’ll also choose to take the distributions based off your own life expectancy or by using the 5 or 10-year rule.',
      ],
      bulletsRoth: [
        'Distributions can be taken out at any time, penalty-free, if the 5-year holding period for Roth IRAs was met and the decedent was at least 59.5 years old.',
        'If the account has not met the 5-year holding period, withdrawals of earnings may be subject to income tax.',
      ],
    },
    rmd: {
      title: 'Required Minimum Distribution (RMD)',
      description:
        'RMD options vary based on the decedent’s age and year of passing. For specific requirements regarding your inheritance, please visit the IRS website on ',
      descriptionRoth:
        'RMD requirements vary based on the decedent’s age and year of passing. Please visit the IRS website to learn more about ',
      rmdLinkLabel: 'retirement topics.',
      rmdLinkLabelRoth: 'RMD requirements for Roth IRAs',
      rmdLink: 'https://investor.vanguard.com/inherit/ira-rmd',
    },
  },
  rmd: 'Read more about RMD rules for inherited IRAs',
  rmdLink: 'https://investor.vanguard.com/inherit/ira-rmd',
};
